import { useCoreQuery } from '@tecsinapse-org/portal-menu-kit'
import { useEffect } from 'react'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { homeTour } from '../components/home-tour'

export const useHomeOnboarding = () => {
  const { currentUserOnboardingIsSeen, setSteps, setOpen, loading, save } =
    useOnboarding(Onboardings.HOME)
  const { data } = useCoreQuery()

  useEffect(() => {
    if (!currentUserOnboardingIsSeen && !loading) {
      setSteps?.([...homeTour(String(data?.title), save)])
      setOpen()
    }
  }, [currentUserOnboardingIsSeen, data, setOpen, setSteps, loading, save])

  return { linkHelpTec: data?.linkHelpTec }
}
